import { z } from 'zod';
// Zod schema for validation (more generic than SourQuery due to complex union type)
export const SourQuerySchema = z.object({
    type: z.string().optional(),
    query: z
        .object({
        query: z.string(),
        restrictToFields: z.array(z.string()).optional(),
    })
        .optional(),
    sort: z
        .object({
        field: z.string().optional(),
        direction: z.enum(['ASC', 'DESC']).optional(),
    })
        .optional(),
    filters: z.record(z.any()).optional(),
});
//# sourceMappingURL=schema.js.map